export default __webpack_public_path__ + "static/media/elina@3x.7941fd44.png";